// const API_URL = "http://sourceman.harrys:8000/api";
const API_URL = "https://source.iloveweb.gr/api";
// const API_URL = "http://clockme.harrys:8000/api";

const SERVICE_TYPE = {
    NORMAL: 1,
    SUBSCRIPTION: 2,
};

const SERVICE_TYPES = [
    '',
    'Κανονική',
    'Συνδρομή'
];

const SERVICE_CUSTOM_FIELD = {
    TEXT: 0,
    NUMBER: 1,
    DATE: 2,
};

const SERVICE_CUSTOM_FIELDS = [
    'Κείμενο',
    'Αριθμός',
    'Ημερομηνία',
];


const SUBSCRIPTION_NOTIFICATIONS = [
    '1η ειδοποίηση πριν την λήξη συνδρομής',
    '2η ειδοποίηση πριν την λήξη συνδρομής',
    'Ειδοποίηση λήξης συνδρομής',
    'Ειδοποίηση ανανέωσης συνδρομής'
];


const COLORS = [
    'f44336',
    'e91e63',
    'ff5722',
    'ff9800',
    'ffc107',
    '8bc34a',
    '4caf50',
    '00bcd4',
    '009688',
    '03a9f4',
    '3f51b5',
    '673ab7',
    '9c27b0',
    '607d8b',
    '795548',
];

const OBJECTS = {
    NONE: 0,
    CLIENT: 1,
    PROJECT: 2,
    SERVICE: 3,
    SUBSCRIPTION: 4,
    TASK: 5,
    CLOCKING_TASK: 6,
};

export {
    API_URL,
    SERVICE_TYPE,
    SERVICE_TYPES,
    SERVICE_CUSTOM_FIELD,
    SERVICE_CUSTOM_FIELDS,
    SUBSCRIPTION_NOTIFICATIONS,
    COLORS,
    OBJECTS,
}